var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6777 6.16316L15.2575 6.37798C10.791 7.0536 7.70266 8.7212 5.58935 11.2981C4.29447 12.877 3.30719 14.8681 2.62195 17.326C3.51192 16.6342 4.46641 16.0376 5.49016 15.5367C8.24485 14.1889 11.4086 13.5791 15.0067 13.5791H16.6767V16.877L22.2763 10.0583L16.6777 3.23594V6.16316ZM17.3391 1.4093C17.1459 1.21179 16.8973 1.07776 16.6261 1.02502C16.355 0.972285 16.0742 1.00335 15.8211 1.11407C15.568 1.2248 15.3547 1.40994 15.2094 1.64488C15.0641 1.87983 14.9938 2.15343 15.0078 2.42931V4.72678C6.49268 6.0148 2.02508 10.8043 0.448452 19.3409C0.257052 20.3772 0.108257 21.4688 0 22.616C0.622021 21.6939 1.28944 20.8631 2.00641 20.121C4.89125 17.1348 8.57817 15.584 13.3367 15.2979C13.8793 15.2652 14.4358 15.249 15.0067 15.249V17.6905C14.9919 17.9669 15.0621 18.2411 15.2077 18.4764C15.3533 18.7117 15.5674 18.8968 15.8213 19.0069C16.0752 19.117 16.3567 19.1468 16.628 19.0922C16.8993 19.0377 17.1474 18.9014 17.3391 18.7018L23.6009 11.0767C23.8575 10.7996 24 10.4359 24 10.0583C24 9.68067 23.8575 9.31698 23.6009 9.03991L17.3391 1.4093Z",
    fill: "#6C74B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/inviteIcon.61ea9d7b22600741a8e53519d40759bf.svg";
export { ForwardRef as ReactComponent };